<template>
  <v-app id="copyHuis">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-text-field v-model="huis_code_from" label="From Acco ID"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="huis_code_to" label="To Acco ID"></v-text-field>
          </v-col>
      </v-row>

      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="copyAcco">Copy</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
  </v-app>
</template>

<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      huis_code_from: '',
      huis_code_to: '',
      param: {}
    }
  },
  methods: {
     copyAcco() {
      
      this.results = true;
      this.$axios
        .post("ares/json/ares/huis/copyHuis.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "copyHuis"
          },
          copyHuis: {
            huis_code_from: this.huis_code_from,
            huis_code_to: this.huis_code_to
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.copyHuis;
            
                 this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.text,
                  color: res.data.color
                 });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
